<div class="min-h-full" style="background-color: #fafaf7;">

  @if (isLoading()) {
    <div class="flex items-center justify-center min-h-[60vh]">
      <div class="flex flex-col items-center gap-5">
        <div class="relative w-12 h-12">
          <div class="absolute inset-0 rounded-full border-4 border-stone-200"></div>
          <div class="absolute inset-0 rounded-full border-4 border-t-primary-400 animate-spin"></div>
        </div>
        <p class="text-stone-600 font-medium text-sm">Chargement…</p>
      </div>
    </div>
  }

  @if (!isLoading()) {
    <div class="max-w-[1200px] mx-auto px-5 sm:px-8 py-8 space-y-6">

      @if (errorMessage()) {
        <div class="p-4 rounded-2xl bg-red-50 border border-red-100 text-sm text-red-700 flex items-center gap-3">
          <span class="material-icons text-base text-red-500">error_outline</span>
          {{ errorMessage() }}
        </div>
      }

      <div class="bg-white rounded-3xl shadow-sm border border-stone-100 overflow-hidden">

        <!-- Toolbar -->
        <div class="px-6 py-4 border-b border-stone-100 flex items-center gap-3 flex-wrap">
          <div class="relative flex-1 min-w-0 max-w-sm">
            <svg class="absolute left-4 top-1/2 -translate-y-1/2 w-4 h-4 text-stone-400 pointer-events-none" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
              <path stroke-linecap="round" stroke-linejoin="round" d="M21 21l-5.197-5.197m0 0A7.5 7.5 0 105.196 5.196a7.5 7.5 0 0010.607 10.607z" />
            </svg>
            <input type="search"
              class="w-full bg-white border border-stone-200 text-stone-800 placeholder-stone-400 text-sm rounded-lg pl-11 pr-8 py-2 outline-none focus:border-primary-300 focus:ring-2 focus:ring-primary-100 transition-all"
              placeholder="Rechercher un événement…"
              (input)="onSearch($any($event.target).value)" />
          </div>
          <select
            class="border border-stone-200 text-stone-700 text-sm rounded-lg pl-3 pr-8 py-2 outline-none focus:border-primary-300 focus:ring-2 focus:ring-primary-100 transition-all bg-white flex-shrink-0"
            [value]="selectedStatus()" (change)="onStatusFilter($any($event.target).value)">
            <option value="">Tous les statuts</option>
            <option value="ACTI">En ligne</option>
            <option value="INAC">Hors ligne</option>
          </select>
          <button (click)="openAddForm()"
            class="inline-flex items-center gap-1.5 px-3 py-1.5 bg-primary-600 text-white rounded-lg hover:bg-primary-700 transition-colors text-xs font-medium flex-shrink-0 ml-auto">
            <span class="material-icons text-base">add</span>Ajouter
          </button>
        </div>

        <!-- Table -->
        <div class="overflow-x-auto">
          <table class="w-full text-sm" role="table">
            <thead>
              <tr class="border-b border-stone-100 bg-stone-50">
                <th class="px-3 py-3 text-left text-xs font-medium text-stone-500 uppercase tracking-wider w-[48px]">ID</th>
                <th class="px-4 py-3 text-left text-xs font-medium text-stone-500 uppercase tracking-wider">Titre</th>
                <th class="px-4 py-3 text-left text-xs font-medium text-stone-500 uppercase tracking-wider w-[180px] hidden md:table-cell">Description</th>
                <th class="px-2 py-3 text-left text-xs font-medium text-stone-500 uppercase tracking-wider w-[69px]">Année</th>
                <th class="px-4 py-3 text-left text-xs font-medium text-stone-500 uppercase tracking-wider w-[112px]">Statut</th>
                <th class="px-4 py-3 text-left text-xs font-medium text-stone-500 uppercase tracking-wider w-[110px]">Actions</th>
              </tr>
            </thead>
            <tbody class="divide-y divide-stone-50">

              @if (filteredEvents().length === 0) {
                <tr>
                  <td colspan="6" class="px-6 py-16 text-center">
                    <div class="flex flex-col items-center gap-3">
                      <div class="w-14 h-14 rounded-3xl bg-stone-100 flex items-center justify-center">
                        <span class="material-icons text-2xl text-stone-300">history</span>
                      </div>
                      @if (searchQuery()) {
                        <p class="text-stone-500 text-sm font-medium">Aucun résultat pour "{{ searchQuery() }}"</p>
                      } @else {
                        <p class="text-stone-500 text-sm font-medium">Aucun événement historique</p>
                        <p class="text-stone-400 text-xs">Cliquez sur "Ajouter" pour créer le premier événement</p>
                      }
                    </div>
                  </td>
                </tr>
              }

              @for (event of filteredEvents(); track event.id_event) {
                <tr class="hover:bg-stone-50 transition-colors duration-150 cursor-pointer"
                    (click)="openEditForm(event)">

                  <td class="px-3 py-3 w-[48px]">
                    <span class="text-xs font-mono text-stone-400">#{{ event.id_event }}</span>
                  </td>
                  <td class="px-4 py-3">
                    <p class="font-semibold text-stone-800 text-xs truncate">{{ event.title }}</p>
                  </td>
                  <td class="px-4 py-3 w-[180px] hidden md:table-cell" style="max-width:180px">
                    <p class="text-xs text-stone-400 truncate">{{ event.description || '—' }}</p>
                  </td>
                  <td class="px-2 py-3 w-[69px] whitespace-nowrap">
                    <span class="text-xs text-stone-500 font-mono">{{ event.year }}</span>
                  </td>

                  <!-- Statut badge -->
                  <td class="px-4 py-3 w-[112px]" (click)="$event.stopPropagation()">
                    <span class="inline-flex items-center gap-1.5 text-xs font-medium px-2.5 py-1 rounded-full border whitespace-nowrap"
                      [class]="statusBadgeClass(event.status || 'ACTI')">
                      <span class="w-1.5 h-1.5 rounded-full flex-shrink-0"
                        [class]="(event.status || 'ACTI') === 'ACTI' ? 'bg-emerald-500' : 'bg-amber-400'"></span>
                      {{ statusLabel(event.status || 'ACTI') }}
                    </span>
                  </td>

                  <!-- Actions -->
                  <td class="px-4 py-3 w-[110px]" (click)="$event.stopPropagation()">
                    <div class="flex items-center gap-1">
                      <!-- Modifier -->
                      <button (click)="openEditForm(event)" title="Modifier"
                        class="w-7 h-7 rounded-lg flex items-center justify-center text-stone-400 hover:bg-primary-50 hover:text-primary-600 transition-all">
                        <svg class="w-3.5 h-3.5" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                          <path stroke-linecap="round" stroke-linejoin="round" d="M16.862 4.487l1.687-1.688a1.875 1.875 0 112.652 2.652L10.582 16.07a4.5 4.5 0 01-1.897 1.13L6 18l.8-2.685a4.5 4.5 0 011.13-1.897l8.932-8.931z" />
                        </svg>
                      </button>
                      <!-- Désactiver / Activer -->
                      @if ((event.status || 'ACTI') === 'ACTI') {
                        <button (click)="confirmStatus(event, 'INAC', $event)" title="Désactiver"
                          class="w-7 h-7 rounded-lg flex items-center justify-center text-stone-400 hover:bg-amber-50 hover:text-amber-500 transition-all">
                          <svg class="w-3.5 h-3.5" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                            <path stroke-linecap="round" stroke-linejoin="round" d="M18.364 18.364A9 9 0 005.636 5.636m12.728 12.728A9 9 0 015.636 5.636m12.728 12.728L5.636 5.636" />
                          </svg>
                        </button>
                      } @else {
                        <button (click)="confirmStatus(event, 'ACTI', $event)" title="Activer"
                          class="w-7 h-7 rounded-lg flex items-center justify-center text-stone-400 hover:bg-emerald-50 hover:text-emerald-600 transition-all">
                          <svg class="w-3.5 h-3.5" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                            <path stroke-linecap="round" stroke-linejoin="round" d="M9 12.75L11.25 15 15 9.75M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                          </svg>
                        </button>
                      }
                      <!-- Archiver -->
                      <button (click)="confirmArchive(event.id_event, $event)" title="Archiver"
                        class="w-7 h-7 rounded-lg flex items-center justify-center text-stone-400 hover:bg-red-50 hover:text-red-500 transition-all">
                        <svg class="w-3.5 h-3.5" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                          <path stroke-linecap="round" stroke-linejoin="round" d="M20.25 7.5l-.625 10.632a2.25 2.25 0 01-2.247 2.118H6.622a2.25 2.25 0 01-2.247-2.118L3.75 7.5m8.25 3v6.75m0 0l-3-3m3 3l3-3M3.375 7.5h17.25c.621 0 1.125-.504 1.125-1.125v-1.5c0-.621-.504-1.125-1.125-1.125H3.375c-.621 0-1.125.504-1.125 1.125v1.5c0 .621.504 1.125 1.125 1.125z" />
                        </svg>
                      </button>
                    </div>
                  </td>
                </tr>
              }
            </tbody>
          </table>
        </div>
      </div>
    </div>
  }
</div>

<!-- Add / Edit modal -->
@if (showForm()) {
  <div class="fixed inset-0 z-50 flex items-center justify-center bg-black/40 backdrop-blur-sm">
    <div class="bg-white rounded-3xl shadow-xl border border-stone-100 p-6 w-full max-w-md mx-4">
      <div class="flex items-center justify-between mb-5">
        <h3 class="text-base font-semibold text-stone-800">{{ editingEvent() ? 'Modifier l\'événement' : 'Ajouter un événement' }}</h3>
        <button (click)="closeForm()" class="w-8 h-8 rounded-xl flex items-center justify-center text-stone-400 hover:bg-stone-100 transition-all">
          <svg class="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2"><path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" /></svg>
        </button>
      </div>
      @if (errorMessage()) {
        <div class="p-3 rounded-xl bg-red-50 border border-red-100 text-xs text-red-700 mb-4">{{ errorMessage() }}</div>
      }
      <div class="space-y-4">
        <div>
          <label class="block text-xs font-medium text-stone-600 mb-1.5">Année <span class="text-red-500">*</span></label>
          <input type="number" [value]="formData().year" min="1900" max="2100"
            (input)="updateField('year', +$any($event.target).value)"
            class="w-full border border-stone-200 rounded-xl px-3 py-2 text-sm text-stone-800 outline-none focus:border-primary-300 focus:ring-2 focus:ring-primary-100 transition-all" />
        </div>
        <div>
          <label class="block text-xs font-medium text-stone-600 mb-1.5">Titre <span class="text-red-500">*</span></label>
          <input type="text" [value]="formData().title" (input)="updateField('title', $any($event.target).value)"
            placeholder="Titre de l'événement"
            class="w-full border border-stone-200 rounded-xl px-3 py-2 text-sm text-stone-800 placeholder-stone-400 outline-none focus:border-primary-300 focus:ring-2 focus:ring-primary-100 transition-all" />
        </div>
        <div>
          <label class="block text-xs font-medium text-stone-600 mb-1.5">Description</label>
          <textarea [value]="formData().description" (input)="updateField('description', $any($event.target).value)"
            rows="3" placeholder="Description de l'événement"
            class="w-full border border-stone-200 rounded-xl px-3 py-2 text-sm text-stone-800 placeholder-stone-400 outline-none focus:border-primary-300 focus:ring-2 focus:ring-primary-100 transition-all resize-none"></textarea>
        </div>
      </div>
      <div class="flex items-center justify-end gap-2 mt-6">
        <button type="button" (click)="closeForm()" [disabled]="isSaving()"
          class="px-4 py-2 text-sm font-medium text-stone-600 border border-stone-200 rounded-xl hover:bg-stone-50 disabled:opacity-50 transition-colors">Annuler</button>
        <button type="button" (click)="onSave()" [disabled]="isSaving()"
          class="inline-flex items-center gap-2 px-5 py-2 bg-primary-600 text-white rounded-xl hover:bg-primary-700 disabled:opacity-50 transition-colors text-sm font-semibold">
          @if (isSaving()) { <div class="w-3.5 h-3.5 border-2 border-white border-t-transparent rounded-full animate-spin"></div> }
          @else { <svg class="w-3.5 h-3.5" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2.5"><path stroke-linecap="round" stroke-linejoin="round" d="M4.5 12.75l6 6 9-13.5" /></svg> }
          {{ isSaving() ? 'Enregistrement…' : (editingEvent() ? 'Modifier' : 'Ajouter') }}
        </button>
      </div>
    </div>
  </div>
}

<!-- Confirm status change -->
@if (pendingStatus()) {
  <div class="fixed inset-0 z-50 flex items-center justify-center bg-black/40 backdrop-blur-sm">
    <div class="bg-white rounded-3xl shadow-xl border border-stone-100 p-6 w-full max-w-sm mx-4">
      <div class="flex items-center gap-3 mb-4">
        <div class="w-10 h-10 rounded-2xl flex items-center justify-center flex-shrink-0"
          [class]="pendingStatus()!.status === 'ACTI' ? 'bg-emerald-50' : 'bg-amber-50'">
          @if (pendingStatus()!.status === 'ACTI') {
            <svg class="w-5 h-5 text-emerald-500" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2"><path stroke-linecap="round" stroke-linejoin="round" d="M9 12.75L11.25 15 15 9.75M21 12a9 9 0 11-18 0 9 9 0 0118 0z" /></svg>
          } @else {
            <svg class="w-5 h-5 text-amber-500" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2"><path stroke-linecap="round" stroke-linejoin="round" d="M18.364 18.364A9 9 0 005.636 5.636m12.728 12.728A9 9 0 015.636 5.636m12.728 12.728L5.636 5.636" /></svg>
          }
        </div>
        <div>
          <p class="font-semibold text-stone-800 text-sm">{{ pendingStatus()!.status === 'ACTI' ? 'Activer l\'événement' : 'Désactiver l\'événement' }}</p>
          <p class="text-xs text-stone-500 mt-0.5">{{ pendingStatus()!.status === 'ACTI' ? 'Cet événement sera visible en ligne.' : 'Cet événement sera masqué du site public.' }}</p>
        </div>
      </div>
      <div class="flex gap-2 justify-end">
        <button type="button" (click)="cancelStatus()"
          class="px-4 py-2 text-sm font-medium text-stone-600 border border-stone-200 rounded-xl hover:bg-stone-50 transition-colors">Annuler</button>
        <button type="button" (click)="applyStatus()"
          class="px-4 py-2 text-sm font-medium text-white rounded-xl transition-colors"
          [class]="pendingStatus()!.status === 'ACTI' ? 'bg-emerald-500 hover:bg-emerald-600' : 'bg-amber-500 hover:bg-amber-600'">
          {{ pendingStatus()!.status === 'ACTI' ? 'Activer' : 'Désactiver' }}
        </button>
      </div>
    </div>
  </div>
}

<!-- Confirm archive -->
@if (pendingArchive()) {
  <div class="fixed inset-0 z-50 flex items-center justify-center bg-black/40 backdrop-blur-sm">
    <div class="bg-white rounded-3xl shadow-xl border border-stone-100 p-6 w-full max-w-sm mx-4">
      <div class="flex items-center gap-3 mb-4">
        <div class="w-10 h-10 rounded-2xl bg-red-50 flex items-center justify-center flex-shrink-0">
          <svg class="w-5 h-5 text-red-500" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
            <path stroke-linecap="round" stroke-linejoin="round" d="M20.25 7.5l-.625 10.632a2.25 2.25 0 01-2.247 2.118H6.622a2.25 2.25 0 01-2.247-2.118L3.75 7.5m8.25 3v6.75m0 0l-3-3m3 3l3-3M3.375 7.5h17.25c.621 0 1.125-.504 1.125-1.125v-1.5c0-.621-.504-1.125-1.125-1.125H3.375c-.621 0-1.125.504-1.125 1.125v1.5c0 .621.504 1.125 1.125 1.125z" />
          </svg>
        </div>
        <div>
          <p class="font-semibold text-stone-800 text-sm">Confirmer l'archivage</p>
          <p class="text-xs text-stone-500 mt-0.5">Cet événement sera archivé et n'apparaîtra plus dans la liste.</p>
        </div>
      </div>
      <div class="flex gap-2 justify-end">
        <button type="button" (click)="cancelArchive()"
          class="px-4 py-2 text-sm font-medium text-stone-600 border border-stone-200 rounded-xl hover:bg-stone-50 transition-colors">Annuler</button>
        <button type="button" (click)="applyArchive()"
          class="px-4 py-2 text-sm font-medium text-white bg-red-500 hover:bg-red-600 rounded-xl transition-colors">Archiver</button>
      </div>
    </div>
  </div>
}
